export const ADMOB_APP_ID = 'ca-app-pub-2521422508709799~4000954179';
export const ADMOB_PUBLISHER_ID = 'ca-app-pub-2521422508709799';
export const ADMOB_BANNER_UNIT_ID = 'ca-app-pub-2521422508709799/3665912250';
export const ADMOB_BANNER_SLOT = '3665912250';

/** Google official test banner — safe for localhost/dev */
export const ADMOB_TEST_PUBLISHER_ID = 'ca-app-pub-3940256099942544';
export const ADMOB_TEST_BANNER_SLOT = '6300978111';

const ADS_ENABLED = process.env.REACT_APP_ADS_ENABLED !== 'false';

function parseBannerUnitId(unitId) {
  const match = unitId.match(/^(ca-app-pub-\d+)\/(\d+)$/);
  if (!match) return null;
  return { publisherId: match[1], slotId: match[2] };
}

function isLocalDevHost() {
  if (typeof window === 'undefined') return process.env.NODE_ENV !== 'production';
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1';
}

export function getAdConfig() {
  if (!ADS_ENABLED) return null;

  const useTestAds =
    process.env.REACT_APP_ADS_USE_TEST === 'true' || isLocalDevHost();

  if (useTestAds) {
    return {
      publisherId: ADMOB_TEST_PUBLISHER_ID,
      slotId: ADMOB_TEST_BANNER_SLOT,
      isTest: true,
    };
  }

  const unitId = process.env.REACT_APP_ADMOB_BANNER_UNIT_ID || ADMOB_BANNER_UNIT_ID;
  const parsed = parseBannerUnitId(unitId);
  if (!parsed) return null;

  return { ...parsed, isTest: false };
}

export function areAdsEnabled() {
  return ADS_ENABLED && getAdConfig() !== null;
}
